import React, { Component } from "react";
import "./styles.css";
import html2canvas from "html2canvas";
import Circle from "./shapes/Circle";
import Triangle from "./shapes/Triangle";
import Square from "./shapes/Square";
import Corner from "./shapes/Corner";
import CircleHalf from "./shapes/CircleHalf";
import CircleCorner from "./shapes/CircleCorner";
import CircleLine from "./shapes/CircleLine";
import Grid from "./shapes/Grid";
import Empty from "./shapes/Empty";
import Dots from "./shapes/Dots";
import Reload from "./icons/Reload";
import Download from "./icons/Download";

const SIZE = 100;
class App extends Component {
  state = {
    full: [],
    shapes: [
      <Empty size={SIZE} />,
      <Empty size={SIZE} />,
      <Empty size={SIZE} />,
      <Circle color={"#E24A8A"} size={SIZE} />,
      <Triangle color={"#C94643"} size={SIZE} />,
      <Square color="teal" size={SIZE} />,
      <CircleLine color="#DD6E3B" size={SIZE} />,
      <Grid color="#C6DE5A" size={SIZE} />,
      <Corner color="cyan" size={SIZE} />,
      <Dots color="#9970D7" size={SIZE} />,
      <CircleHalf color="lightBlue" size={SIZE} />,
      <CircleCorner color="#35DE9D" size={SIZE} />
    ]
  };

  componentDidMount = () => {
    this.generate();
  };

  generate = () => {
    let shapes = this.state.shapes;
    let full = [];
    let min = 0;
    let max = shapes.length;
    for (var i = 0; i < 100; i++) {
      let rand = Math.floor(min + Math.random() * (max - min));
      console.log(shapes[rand]);
      full.push(shapes[rand]);
    }
    this.setState({ full });
  };

  download = () => {
    let element = document.getElementById("canvas");
    html2canvas(element, {
      scale: 3.0,
      width: 800,
      height: 600,
      backgroundColor: null,
      logging: false
    })
      .then(canvas => {
        console.log("Downloadingg...");
        let data = canvas.toDataURL("image/png");
        data = data.replace(
          /^data:image\/[^;]*/,
          "data:application/octet-stream"
        );
        data = data.replace(
          /^data:application\/octet-stream/,
          "data:application/octet-stream;headers=Content-Disposition%3A%20attachment%3B%20filename=Canvas.png"
        );
        let rand = new Date().getTime() / 1000;
        let link = document.createElement("a");
        link.download = `shape-${rand}.png`;
        link.href = data;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(link.href);
      })
      .catch(error => {
        console.error("oops, something went wrong!", error);
      });
  };

  render = () => {
    return (
      <div className="App">
        <div id="canvas" className="wrap">
          {this.state.full}
          {/* <p>adad</p> */}
        </div>
        <div>
          <button onClick={() => this.generate()}>
            <Reload size={20} /> Reload
          </button>
          <button onClick={() => this.download()}>
            <Download size={20} /> Download
          </button>
        </div>
      </div>
    );
  };
}

export default App;
